import styled from '@emotion/styled'
import { colors, typo } from '@mathflat/common/style'

import { DATE_PICKER_COMPONENT } from '@/constant/ui/DOM'
import { webkit } from '@/styles'

const S = {
  Wrapper: styled.div`
    ${webkit.removeHighlight};
    position: relative;
    display: flex;
    align-items: center;
    width: 130px;
    height: 40px;
    padding: 0 12px;
    border: 1px solid ${colors.gray.$400};
    border-radius: var(--Radius-100);

    &.disabled {
      background-color: ${colors.gray.$100};
      cursor: not-allowed;
      input {
        background-color: transparent;
      }
    }

    &.focused {
      border: 1px solid ${colors.gray.$800};
    }

    &.error {
      border: 1px solid ${colors.red.$400};
    }

    .error-message {
      position: absolute;
      top: 42px;
      left: 0;
      color: ${colors.red.$400};
      ${typo.caption01};
    }

    .${DATE_PICKER_COMPONENT} {
      display: none;
      &.visible {
        display: block;
      }
    }
  `,
}

export default S
